import { useState } from "react";
import { api, ApiError } from "../api";
import { ErrorNote } from "../components/ui";
import { PeriodFilters } from "../components/PeriodFilters";
import { useLocations } from "../hooks";
import type { Filters } from "../types";

export default function Reports() {
  const locations = useLocations();
  const [filters, setFilters] = useState<Filters>({});
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState<"csv" | "xlsx" | null>(null);

  const download = async (format: "csv" | "xlsx") => {
    setBusy(format);
    setError(null);
    try {
      const blob = await api.exportReport(filters, format);
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `attendance-${filters.location ?? "all"}.${format}`;
      a.click();
      URL.revokeObjectURL(url);
    } catch (e) {
      setError((e as ApiError).message);
    } finally {
      setBusy(null);
    }
  };

  return (
    <div>
      <h1 className="h1">Reports</h1>
      <p className="sub">Export the filtered dataset. Each file includes the period and location.</p>
      <PeriodFilters locations={locations} initialMode="month" showSearch
                     storageKey="reports" onChange={setFilters} />
      <div className="row" style={{ marginTop: 18 }}>
        <button className="primary" disabled={busy !== null} onClick={() => download("csv")}>
          {busy === "csv" ? "Preparing…" : "Download CSV"}
        </button>
        <button className="primary" disabled={busy !== null} onClick={() => download("xlsx")}>
          {busy === "xlsx" ? "Preparing…" : "Download Excel"}
        </button>
      </div>
      {error && <ErrorNote message={error} />}
    </div>
  );
}
